import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { apiAction } from "@client/lib/actions";
import { type BaseAppState, type EntityRef, type OptionItem, Status } from "@client/types";
import { type Dispatch } from "redux";
import { initAction } from "../actions";
import api from "./api";
import { localStateSelector } from "./selectors";
import { type NetworkPlacement } from "./types";

export enum Actions {
  InitBegin = "NETWORK_SETTINGS_INIT_BEGIN",
  InitFailure = "NETWORK_SETTINGS_INIT_FAILURE",
  InitSuccess = "NETWORK_SETTINGS_INIT_SUCCESS",

  SaveBegin = "NETWORK_SETTINGS_SAVE_BEGIN",
  SaveFailure = "NETWORK_SETTINGS_SAVE_FAILURE",
  SaveSuccess = "NETWORK_SETTINGS_SAVE_SUCCESS"
}

export type InitBeginActionData = EntityRef;
export interface InitSuccessActionData {
  placementSettingOptions: OptionItem[];
  settings: NetworkPlacement.Setting[];
}
export const _init = initAction<
  BaseAppState,
  InitBeginActionData,
  NetworkPlacement.Api.InitResponse,
  InitSuccessActionData
>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: (state: BaseAppState, dispatch: any, args: InitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);
    return api.init(apiInfo, {});
  }
});

export type InitArgs = EntityRef & {};
export const init = (args: InitArgs) => (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
  const state = getState();
  const localState = localStateSelector(state, args);
  if (localState.status === Status.None) {
    dispatch(_init(args));
  }
};

export type UpdateSettingsBeginActionData = UpdateSettingsActionData;
export interface UpdateSettingsSuccessActionData {}
export const _save = apiAction<
  BaseAppState,
  UpdateSettingsBeginActionData,
  NetworkPlacement.Api.UpdateSettingsResponse,
  UpdateSettingsSuccessActionData
>({
  types: {
    begin: Actions.SaveBegin,
    failure: Actions.SaveFailure,
    success: Actions.SaveSuccess
  },
  action: (state: BaseAppState, dispatch: any, args: UpdateSettingsBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);
    return api.save(apiInfo, args);
  }
});

export type UpdateSettingsActionData = EntityRef & {
  settings: NetworkPlacement.SettingSettings[];
};
export const save =
  (args: UpdateSettingsActionData) => async (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
    const state = getState();
    const localState = localStateSelector(state, args);

    if (localState.status !== Status.Saving) {
      dispatch(_save(args));
    }
  };
